import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import Spinner from '../../Spinner';
import useUnauthenticated from './vm';

interface Props {
  children: ReactNode;
}

const Unauthenticated = ({ children }: Props) => {
  const { isLoading } = useUnauthenticated();

  if (isLoading) {
    return (
      <Stack height="100%" justifyContent="center" alignItems="center">
        <Spinner size="xLarge" />
      </Stack>
    );
  }

  return <>{children}</>;
};

export default Unauthenticated;
